import styled from "@emotion/styled"
import { FlexContainerAndItem } from "../../../styled/flexbox.styled"

export const SpinnerContainer = styled(FlexContainerAndItem)({
  overflow: "auto",
  padding: "10px 0 10px 0",
})
